module.exports = __webpack_public_path__ + "static/media/Planning.508b3a43.jpg";